import React from 'react';
export function Logo() {
  return <a href="#top" className="flex items-center gap-2.5" aria-label="Evaluación Fitness Jseefect, ir al inicio" data-id="element-287" data-mp="3lhscbb8cgrkc">
      <span className="flex h-8 w-8 items-center justify-center rounded-sm bg-brand font-display text-xl font-black text-white" data-id="element-288" data-mp="wowdkkjuv5us">
        J
      </span>
      <span className="flex flex-col leading-none" data-id="element-289" data-mp="nvaxmxvyfijs">
        <span className="font-display text-2xl font-black uppercase tracking-wide text-white" data-id="element-290" data-mp="nseyj68dentr">Jseefect</span>
        <span className="mt-0.5 hidden text-[0.65rem] font-semibold uppercase tracking-[0.2em] text-muted sm:block" data-id="element-291" data-mp="it26m72n6qkb">
          Evaluación Fitness
        </span>
      </span>
    </a>;
}